import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private serviceCount = 0;
  constructor(private loaderService: LoaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.url.includes('ai-service')) {
      return next.handle(request);
    }
    this.loaderService.show();
    this.serviceCount++;
    return next.handle(request).pipe(
      finalize(() => {
        this.serviceCount--;
        if (this.serviceCount === 0) {
          this.loaderService.hide();
        }
      })
    );
  }
}
